import React, { useState } from "react";
import TrainerFeedbackForm from "./TrainerFeedbackForm";
import PopUps from "./PopUps";
import { Button } from "@mui/material";

const TrainerFeedbackPopUp = ({ data }) => {
    const [open, setOpen] = useState(false);

    const handleClick = () => {
        setOpen(true);
    };

    const componetProps = {
        row: data,
    };

    return (
        <div>
            <Button variant="contained" onClick={handleClick}>
                View
            </Button>

            <PopUps
                open={open}
                setOpen={setOpen}
                componentProps={componetProps}
                component={TrainerFeedbackForm}
            />
        </div>
    );
};

export default TrainerFeedbackPopUp;
